module.exports = __webpack_public_path__ + "static/media/bannerImage.73328ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/bannerImage.png
// module id = 377
// module chunks = 0